import {getCookieField} from './cookie';

const ROCKSTAT_FIELD_NAME = 'rst-uid';

// используем значение из cookie , т.к. rstat('getUid') становится доступен только после запуска rockstat agent
// rockat uid передаем при каждом вызове на сервер
export const getRockstatUid = () => getCookieField(ROCKSTAT_FIELD_NAME);
